import { Currencies } from "@orbital/games-frontend-library";
import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  BetInputWrapper,
  Currency,
  InputWrapper,
  InputBox,
} from "../ElementsStyles";
import BetOperations from "./BetOperations";
import { AppContext } from "../../../../context/createContext";

import floorFigure from "../../../configs/floorFigure";
import { handleBlur, handleChange } from "../helpers/betInputValidation";
import { logger } from "../../../../helpers/logger";
import { useTranslation } from "../../../../locale/context";

interface Betinput_props {
  stake: string;
  handleStake: any;
  disabled: any;
}

export default function BetInput({
  stake,
  handleStake,
  disabled,
}: Betinput_props) {
  const { config, auth, handleNotification } = useContext(AppContext);

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      betAmount: t("input.betAmountLabel"),
    };
  }, [t]);

  const {
    balance: { currency },
  } = auth;
  const { minbet, maxbet, prec } = config;

  const [stakeValue, setStakeValue] = useState("");
  const [focus, setFocus] = useState<boolean>(false);

  const onChange = (e: any) => handleChange(e, setStakeValue, prec);

  const Blur = (e: any) => {
    handleBlur(
      e,
      minbet,
      maxbet,
      prec,
      handleStake,
      setStakeValue,
      stakeValue,
      handleNotification,
      currency
    );
    e.target.placeholder = (+minbet).toFixed(config.prec);
    setFocus(false);
  };

  const Focus = (e: any) => {
    e.target.placeholder = "";
    setFocus(true);
    e.currentTarget.select();
  };

  useEffect(() => {
    setStakeValue(floorFigure(stake, prec));
    handleStake(floorFigure(stake, prec));
  }, [stake, prec]);

  return (
    <BetInputWrapper className="BetInputWrapper">
      <InputBox focus={focus} disabled={disabled}>
        <label htmlFor="bet">{languagePack.betAmount}</label>
        <InputWrapper focus={focus} disabled={disabled}>
          <Currency>{Currencies[currency]}</Currency>
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input
              name="bet"
              value={stakeValue}
              onChange={(e) => onChange(e)}
              onFocus={(e: any) => Focus(e)}
              onBlur={(e: any) => Blur(e)}
              placeholder={stakeValue}
              inputMode="decimal"
            />
          </form>
        </InputWrapper>
      </InputBox>
      <BetOperations
        stake={stake}
        handleStake={handleStake}
        disabled={disabled}
      />
    </BetInputWrapper>
  );
}
